export default (function () {
	var service = {
		getType: getType
	};

	function BaseEnum() { }
	BaseEnum.prototype = {
		constructor: BaseEnum,
		properties: {},
		asArray: function () {
			var result = [];

			// eslint-disable-next-line no-unused-vars
			for (const key in this.properties) {
				result.push({
					id: key,
					name: this.properties[key].name
				});
			}
			return result;
		},
		asOptions: function () {
			var result = [];

			// eslint-disable-next-line no-unused-vars
			for (const key in this.properties) {
				result.push({
					value: key,
					name: this.properties[key].name
				});
			}
			return result;
		},
		add: function (k, v) {
			this[k] = v;
		},
		get: function (id) {
			return this.properties[id];
		}
	};

	const mediaClass = new BaseEnum();

	mediaClass.add('UNKNOWN', 0);
	mediaClass.add('VIDEO', 1);
	mediaClass.add('PRESENTATION', 2);
	mediaClass.add('PRINT', 3);
	mediaClass.add('AUDIO', 4);
	mediaClass.add('EMAIL', 5);
	mediaClass.add('NEWSLETTER', 6);
	mediaClass.properties = {
		0: {
			name: 'Unknown'
		},
		1: {
			name: 'Video'
		},
		2: {
			name: 'Presentation'
		},
		3: {
			name: 'Print'
		},
		4: {
			name: 'Audio'
		},
		5: {
			name: 'Email'
		},
		6: {
			name: 'Newsletter'
		}
	};

	const scheduleTimeZone = new BaseEnum();

	scheduleTimeZone.add('ET', 1);
	scheduleTimeZone.add('CT', 2);
	scheduleTimeZone.add('MT', 3);
	scheduleTimeZone.add('PT', 4);
	scheduleTimeZone.properties = [{
		name: 'ET',
		value: 1,
		zoneName:'America/New_York'
	},
	{
		name: 'CT',
		value: 2,
		zoneName:'America/Chicago'
	},
	{
		name: 'MT',
		value: 3,
		zoneName:'America/Denver'

	},
	{
		name: 'PT',
		value: 4,
		zoneName:'America/Los_Angeles'
	}];

	const mediaTypes = new BaseEnum();

	mediaTypes.add('VIDEO', 1);
	mediaTypes.add('PRESENTATION', 2);
	mediaTypes.add('ARTICLE', 3);
	mediaTypes.add('AUDIO', 4);
	mediaTypes.add('EMAIL', 5);
	mediaTypes.add('EBOOK', 6);
	mediaTypes.add('INFOGRAPHIC', 7);
	mediaTypes.add('ONESHEET', 8);
	mediaTypes.add('NEWSLETTER', 9);
	mediaTypes.properties = {
		1: {
			name: 'Video'
		},
		2: {
			name: 'Presentation'
		},
		3: {
			name: 'Article'
		},
		4: {
			name: 'Audio'
		},
		5: {
			name: 'Email'
		},
		6: {
			name: 'eBook'
		},
		7: {
			name: 'Infographic'
		},
		8: {
			name: 'One Sheet'
		},
		9: {
			name: 'Newsletter'
		}
	};

	const reviewStatuses = new BaseEnum();

	reviewStatuses.add('TO_BE_REVIEWED', 1);
	reviewStatuses.add('DENIED', 3);
	reviewStatuses.add('ACTION_REQUIRED', 4);
	reviewStatuses.add('APPROVED', 5);
	reviewStatuses.properties = {
		1: {
			name: 'To Be Reviewed', action: 'To Be Reviewed'
		},
		3: {
			name: 'Denied', action: 'Deny'
		},
		4: {
			name: 'Action Required', action: 'Action Required'
		},
		5: {
			name: 'Approved', action: 'Approve'
		}
	};

	const shareTypes = new BaseEnum();

	shareTypes.add('LINK', 1);
	shareTypes.add('EMAIL', 2);
	shareTypes.add('LINKEDIN', 3);
	shareTypes.add('FACEBOOK', 4);
	shareTypes.add('TWITTER', 5);
	shareTypes.add('EMBED', 6);
	shareTypes.properties = {
		1: {
			name: 'Link', title: 'Share This Link', desc: 'Copy the link below to share with clients or prospects'
		},
		2: {
			name: 'Email', title: '', desc: ''
		},
		3: {
			name: 'LinkedIn', title: 'Share on LinkedIn', desc: 'Copy the link below to share from your LinkedIn profile'
		},
		4: {
			name: 'Facebook', title: 'Share on Facebook', desc: 'Copy the link below to share from your Facebook profile'
		},
		5: {
			name: 'X (Twitter)', title: 'Share on Twitter', desc: 'Copy the link below to share from your Twitter profile'
		},
		6: {
			name: 'Embed', title: 'Embed On Your Webite', desc: 'Add the code below to your own website to include this video in the page'
		}
	};

	const commentTypes = new BaseEnum();

	commentTypes.add('STORYBOARD', 1);
	commentTypes.add('SHARECOPY', 2);
	commentTypes.add('QUESTION', 3);
	commentTypes.add('OTHER', 4);
	commentTypes.properties = {
		1: {
			name: 'Storyboard'
		},
		2: {
			name: 'Share Copy'
		},
		3: {
			name: 'Question'
		},
		4: {
			name: 'Other'
		}
	};

	const fileTypes = new BaseEnum();

	fileTypes.add('OTHER', 1);
	fileTypes.add('STORYBOARD', 2);
	fileTypes.add('SOURCES', 3);
	fileTypes.add('TRANSCRIPT', 4);
	fileTypes.add('FINRA', 5);
	fileTypes.add('COMPLIANCE_VIDEO', 6);
	fileTypes.properties = {
		1: {
			name: 'Other'
		},
		2: {
			name: 'Storyboard'
		},
		3: {
			name: 'Sources'
		},
		4: {
			name: 'Transcript'
		},
		5: {
			name: 'FINRA Review Letter'
		},
		6: {
			name: 'Compliance Video'
		}
	};

	const eventTypes = new BaseEnum();

	eventTypes.add('MEDIA_SHARE', 1);
	eventTypes.add('MEDIA_VIEW', 2);
	eventTypes.add('VIDEO_START', 100);
	eventTypes.add('VIDEO_COMPLETE', 101);
	eventTypes.add('DOCUMENT_DOWNLOAD', 200);
	eventTypes.add('DOCUMENT_VIEW', 201);
	eventTypes.add('EMAIL_NOTIFICATION', 300);
	eventTypes.add('EMAIL_SENT', 301);
	eventTypes.add('EMAIL_UNSUBSCRIBE', 302);

	const campaignEventTypes = new BaseEnum();

	campaignEventTypes.add('PAGE_VIEW', 1);
	campaignEventTypes.add('FORM_SUBMISSION', 2);
	campaignEventTypes.add('VIDEO_START', 3);
	campaignEventTypes.add('VIDEO_COMPLETE', 4);

	const contactTypes = new BaseEnum();

	contactTypes.add('CLIENTS', 1);
	contactTypes.add('GROUPS', 2);
	contactTypes.add('ADDITIONAL', 3);
	contactTypes.add('IMPORT', 4);
	contactTypes.add('REDTAIL_GROUPS', 5);
	contactTypes.properties = {
		1: {
			name: 'Clients'
		},
		2: {
			name: 'Groups'
		},
		3: {
			name: 'Additional'
		},
		4: {
			name: 'Import'
		},
		5: {
			name: 'Redtail Groups'
		}
	};

	const emailFolderTypes = new BaseEnum();

	emailFolderTypes.add('DRAFTS', 1);
	emailFolderTypes.add('TEMPLATES', 2);
	emailFolderTypes.add('SCHEDULED', 3);
	emailFolderTypes.add('SENT', 4);
	emailFolderTypes.properties = {
		1: {
			name: 'My Drafts'
		},
		2: {
			name: 'My Templates'
		},
		3: {
			name: 'Scheduled'
		},
		4: {
			name: 'Sent'
		}
	};

	const emailEventType = new BaseEnum();

	emailEventType.add('UNKNOWN', 0);
	emailEventType.add('DELIVERED', 1);
	emailEventType.add('COMPLAINT', 2);
	emailEventType.add('FAILED', 3);
	emailEventType.add('VALIDATION', 4);
	emailEventType.add('TRACKING', 5);
	emailEventType.properties = {
		0: {
			name: 'Unknown'
		},
		1: {
			name: 'Delivered'
		},
		2: {
			name: 'Complaint'
		},
		3: {
			name: 'Failed'
		},
		4: {
			name: 'Validation'
		},
		5: {
			name: 'Tracking'
		}
	};

	const emailTrackingType = new BaseEnum();

	emailTrackingType.add('CLICK', 0);
	emailTrackingType.add('OPEN', 1);
	emailTrackingType.add('UNSUBSCRIBE', 2);
	emailTrackingType.properties = {
		0: {
			name: 'Click'
		},
		1: {
			name: 'Open'
		},
		2: {
			name: 'Unsubscribe'
		}
	};

	const headerOptionTypes = new BaseEnum();

	headerOptionTypes.add('NOHEADER', 1); // no longer used
	headerOptionTypes.add('CENTERED', 2);
	headerOptionTypes.add('LEFTALIGN', 3);
	headerOptionTypes.properties = {
		1: {
			name: 'No Header'
		},
		2: {
			name: 'Center'
		},
		3: {
			name: 'Align Left'
		}
	};

	const languages = new BaseEnum();

	languages.add('ENGLISH', 1);
	languages.add('SPANISH', 2);
	languages.properties = {
		1: {
			name: 'English'
		},
		2: {
			name: 'Spanish'
		}
	};

	const mediaSources = new BaseEnum();

	mediaSources.add('EMA', 'ema');
	mediaSources.add('FMEX', 'fmex');
	mediaSources.properties = {
		'ema': {
			id: 1, name: 'eMoney Advisor'
		},
		'fmex': {
			id: 2, name: 'FMeX'
		}
	};

	const messageStatus = new BaseEnum();

	messageStatus.add('PENDING', 1);
	messageStatus.add('SENT', 2);
	messageStatus.add('DELIVERED', 3);
	messageStatus.add('FAILED', 4);
	messageStatus.properties = {
		1: {
			name: 'Pending'
		},
		2: {
			name: 'Sent'
		},
		3: {
			name: 'Delivered'
		},
		4: {
			name: 'Failed'
		}
	};

	const trackTypes = new BaseEnum();

	trackTypes.add('SUBTITLE', 1);
	trackTypes.add('CAPTION', 2);
	trackTypes.properties = {
		1: {
			name: 'Subtitles'
		},
		2: {
			name: 'Captions'
		}
	};

	const userRoles = new BaseEnum();

	userRoles.add('ASSISTANT', 3);
	userRoles.add('PLANNER', 5);
	userRoles.add('MARKETINGSPECIALIST', 12);

	const campaignTypes = new BaseEnum();

	campaignTypes.add('LEADGEN', 1);
	campaignTypes.add('ONBOARD', 2);
	campaignTypes.add('ENGAGE', 3);
	campaignTypes.properties = {
		1: {
			name: 'Lead Generation and Nurturing'
		},
		2: {
			name: 'Onboarding'
		},
		3: {
			name: 'Engagement'
		}
	};

	const campaignVisibilty = new BaseEnum();

	campaignVisibilty.add('ALWAYS', 1);
	campaignVisibilty.add('HIDDEN', 2);
	campaignVisibilty.add('DATERANGE', 3);
	campaignVisibilty.properties = {
		1: {
			name: 'Always Visible', altName: 'Visible'
		},
		2: {
			name: 'Hidden', altName: 'Hidden'
		},
		// 3:{
		// 	name: 'Date Range'
		// }

		//TODO: 'Date Range' -> can be added to this enum in MVP2-Campaigns
	};

	const exectionStatus = new BaseEnum();

	exectionStatus.add('SUCCEED', 1);
	exectionStatus.add('FAILED', 2);
	exectionStatus.properties = {
		1: {
			name: 'SUCCESS'
		},
		2: {
			name: 'FAILED'
		}
	};

	const campaignStatus = new BaseEnum();

	campaignStatus.add('DRAFT', 1);
	campaignStatus.add('PUBLISHED', 2);
	campaignStatus.add('COMPLETED', 3);
	campaignStatus.add('INPROGRESS', 4);
	campaignStatus.add('SCHEDULED', 5);
	campaignStatus.properties = {
		1: {
			name: 'DRAFT'
		},
		2: {
			name: 'PUBLISHED',
			type: 'success'
		},
		3: {
			name: 'COMPLETED',
			type: 'success'
		},
		4: {
			name: 'IN PROGRESS',
			type: 'progress'
		},
		5: {
			name: 'SCHEDULED',
			type: 'scheduled'
		}
	};

	const myCampaignsStatus = new BaseEnum();

	myCampaignsStatus.add('DRAFT', 1);
	myCampaignsStatus.add('SCHEDULED', 2);
	myCampaignsStatus.add('ACTIVE', 3);
	myCampaignsStatus.add('INACTIVE', 4);
	myCampaignsStatus.properties = {
		1: {
			name: 'DRAFT'
		},
		2: {
			name: 'SCHEDULED',
			type: 'scheduled'
		},
		3: {
			name: 'ACTIVE',
			type: 'success'
		},
		4: {
			name: 'INACTIVE',
			type: 'inactive'
		},
	};

	const campaignSteps = new BaseEnum();

	campaignSteps.add('BASICINFO', 1);
	campaignSteps.add('CONSTRUCT', 2);
	campaignSteps.add('CUSTOMIZE', 3);
	campaignSteps.add('VERIFY', 4);
	campaignSteps.properties = {
		1: {
			name: 'BASIC INFO'
		},
		2: {
			name: 'CONSTRUCT'
		},
		3: {
			name: 'CUSTOMIZE'
		},
		4: {
			name: 'VERIFY'
		}
	};

	const campaignCreationSteps = new BaseEnum();

	campaignCreationSteps.add('CONSTRUCT', 1);
	campaignCreationSteps.add('CUSTOMIZE', 2);
	campaignCreationSteps.add('VERIFY', 3);
	campaignCreationSteps.properties = {
		1: {
			name: 'CONSTRUCT'
		},
		2: {
			name: 'CUSTOMIZE'
		},
		3: {
			name: 'VERIFY'
		}
	};

	const campaignEmailCategories = new BaseEnum();

	campaignEmailCategories.add('LAUNCH', 1);
	campaignEmailCategories.add('THANKYOU', 2);
	campaignEmailCategories.add('NURTURE', 3);
	campaignEmailCategories.add('OUTREACH', 4);
	campaignEmailCategories.properties = {
		1: {
			name: 'Launch Email'
		},
		2: {
			name: 'Thank You Email'
		},
		3: {
			name: 'Nurture Email'
		},
		4: {
			name: 'Outreach Email'
		}
	};

	const emailType = new BaseEnum();

	emailType.add('EMAIL', 1);
	emailType.add('THANKYOUEMAIL', 2);
	emailType.properties = {
		1: {
			name: 'Email'
		},
		2: {
			name: 'Thank You Email'
		}
	};

	const campaignStartSection = new BaseEnum();

	campaignStartSection.add('Featured', 1);
	campaignStartSection.add('Recent', 2);
	campaignStartSection.add('Favorites', 3);
	campaignStartSection.add('Search', 4);
	campaignStartSection.add('Duplicate', 5);
	campaignStartSection.add('Carousel', 6);
	campaignStartSection.add('Select', 7);
	campaignStartSection.add('Dashboard', 8);
	campaignStartSection.add('TopPerformingCampaigns', 9);
	campaignStartSection.add('CampaignAnalyticsAction', 10);
	campaignStartSection.add('CampaignsTracker', 11);
	campaignStartSection.add('LaunchEmail', 12);
	campaignStartSection.add('ThankYouEmail', 13);
	campaignStartSection.add('NurtureEmail', 14);
	campaignStartSection.add('LandingPageVisitsChart', 15);
	campaignStartSection.properties = {
		1: {
			name: 'Featured'
		},
		2: {
			name: 'Recently Added'
		},
		3: {
			name: 'Favorites'
		},
		4: {
			name: 'Search'
		},
		5: {
			name: 'Duplicate'
		},
		6: {
			name: 'Carousel'
		},
		7: {
			name: 'Create a Campaign'
		},
		8: {
			name: 'Dashboard'
		},
		9: {
			name: 'Top Performing Campaigns'
		},
		10: {
			name: 'Campaign Analytics Actions'
		},
		11: {
			name: 'Campaigns Tracker'
		},
		12: {
			name: 'Launch Email'
		},
		13: {
			name: 'Thank You Email'
		},
		14: {
			name: 'Nurture Email'
		},
		15: {
			name: 'Landing Page Visits Chart'
		}
	};

	const launchEmailPublishOptions = new BaseEnum();

	launchEmailPublishOptions.add('AFTER_CAMPIGN_LANCHED', 1);
	launchEmailPublishOptions.properties = {
		1: {
			name: 'Once the campaign has been launched'
		}
	};

	const nurtureEmailPublishOptions = new BaseEnum();

	nurtureEmailPublishOptions.add('AFTER_LANDING_PAGE_SUBMITTED', 1);
	nurtureEmailPublishOptions.properties = {
		1: {
			name: 'After the Landing Page Form has been Submitted',
			value: 1
		}
	};

	const outreachEmailPublishOptions = new BaseEnum();

	outreachEmailPublishOptions.add('AFTER_LAUNCH_EMAIL_SENT', 1);
	outreachEmailPublishOptions.properties = {
		1: {
			name: 'After the Campaign is launched, to contacts who haven\'t submitted the Landing Page form',
			value: 1
		}
	};

	const Sb1PublishTypes = new BaseEnum();

	Sb1PublishTypes.add('AFTER_CAMPIGN_LAUNCHED', 1);
	Sb1PublishTypes.properties = {
		1: {
			name: 'Once the campaign has been launched',
			value: 1
		}
	};

	const Sb2PublishTypes = new BaseEnum();

	Sb2PublishTypes.add('AFTER_SB1_LAUNCH', 1);
	Sb2PublishTypes.properties = {
		1: {
			name: 'After Social Post #1 has been published',
			value: 1
		}
	};

	const Sb3PublishTypes = new BaseEnum();

	Sb3PublishTypes.add('AFTER_SB1_LAUNCH', 1);
	Sb3PublishTypes.properties = {
		1: {
			name: 'After Social Post #2 has been published',
			value: 1
		}
	};

	const campaignSbTypes = new BaseEnum();

	campaignSbTypes.add('SB1', 1);
	campaignSbTypes.add('SB2', 2);
	campaignSbTypes.add('SB3', 3);
	campaignSbTypes.properties = {
		1: {
			name: 'Social Post 1'
		},
		2: {
			name: 'Social Post 2'
		},
		3: {
			name: 'Social Post 3'
		}
	};

	const defaultSectionFilter = new BaseEnum();

	defaultSectionFilter.add('defaultFavFilter', 0);
	defaultSectionFilter.properties = {
		0: {
			name: 'defaultFavFilter',
			value: 0
		}
	};

	const emailAttachmentFileTypes = new BaseEnum();

	emailAttachmentFileTypes.add('UNDEFINED', 0);
	emailAttachmentFileTypes.add('UNKNOWN', 1);
	emailAttachmentFileTypes.add('PDF', 2);
	emailAttachmentFileTypes.add('JPEG', 3);
	emailAttachmentFileTypes.add('PNG', 4);
	emailAttachmentFileTypes.add('GIF', 5);
	emailAttachmentFileTypes.add('DOC', 6);
	emailAttachmentFileTypes.add('DOCX', 7);
	emailAttachmentFileTypes.add('DOCM', 8);
	emailAttachmentFileTypes.add('JPG', 9);
	emailAttachmentFileTypes.add('XLS', 10);
	emailAttachmentFileTypes.add('XLSX', 11);
	emailAttachmentFileTypes.add('PPT', 12);
	emailAttachmentFileTypes.add('PPTX', 13);
	emailAttachmentFileTypes.properties = {
		0: {
			name: 'undefined'
		},
		1: {
			name: 'unknown'
		},
		2: {
			name: 'pdf'
		},
		3: {
			name: 'jpeg'
		},
		4: {
			name: 'png'
		},
		5: {
			name: 'gif'
		},
		6: {
			name: 'doc'
		},
		7: {
			name: 'docx'
		},
		8: {
			name: 'docm'
		},
		9: {
			name: 'jpg'
		},
		10: {
			name: 'xls'
		},
		11: {
			name: 'xlsx'
		},
		12: {
			name: 'ppt'
		},
		13: {
			name: 'pptx'
		}
	};

	const fileValidationError = new BaseEnum();

	fileValidationError.add('FileSizeExceeded', 1);
	fileValidationError.add('InvalidFileFormat', 2);
	fileValidationError.add('VirusDetected', 3);
	fileValidationError.add('UnknownServerError', 4);
	fileValidationError.add('FileUploadSucceeded', 5);
	fileValidationError.properties = {
		1: {
			name: 'FileSizeExceeded',
			message: 'This file cannot be attached because the email will be too large (over 15 MB)'
		},
		2: {
			name: 'InvalidFileFormat',
			message: 'This file cannot be attached because the file type is not allowed'
		},
		3: {
			name: 'VirusDetected',
			message: 'This file cannot be attached because a virus was detected'
		},
		4: {
			name: 'UnknownServerError',
			message: 'There was an error attaching this file. Please try again'
		},
		5: {
			name: 'FileUploadSucceeded'
		}
	};

	//Returns the supplied enumeration type or throws exception if not found.
	function getType(type) {
		switch (type) {
			case 'mediaClass': return mediaClass;
			case 'mediaTypes': return mediaTypes;
			case 'reviewStatuses': return reviewStatuses;
			case 'commentTypes': return commentTypes;
			case 'shareTypes': return shareTypes;
			case 'fileTypes': return fileTypes;
			case 'eventTypes': return eventTypes;
			case 'contactTypes': return contactTypes;
			case 'headerOptionTypes': return headerOptionTypes;
			case 'emailFolderTypes': return emailFolderTypes;
			case 'messageStatus': return messageStatus;
			case 'userRoles': return userRoles;
			case 'emailEventType': return emailEventType;
			case 'emailTrackingType': return emailTrackingType;
			case 'mediaSources': return mediaSources;
			case 'languages': return languages;
			case 'trackTypes': return trackTypes;
			case 'campaignTypes': return campaignTypes;
			case 'campaignVisibilty': return campaignVisibilty;
			case 'campaignStatus': return campaignStatus;
			case 'myCampaignsStatus': return myCampaignsStatus;
			case 'campaignSteps': return campaignSteps;
			case 'campaignCreationSteps': return campaignCreationSteps;
			case 'campaignEmailCategories': return campaignEmailCategories;
			case 'launchEmailPublishOptions': return launchEmailPublishOptions;
			case 'nurtureEmailPublishOptions': return nurtureEmailPublishOptions;
			case 'outreachEmailPublishOptions': return outreachEmailPublishOptions;
			case 'Sb1PublishTypes': return Sb1PublishTypes;
			case 'Sb2PublishTypes': return Sb2PublishTypes;
			case 'Sb3PublishTypes': return Sb3PublishTypes;
			case 'defaultSectionFilter': return defaultSectionFilter;
			case 'exectionStatus': return exectionStatus;
			case 'campaignStartSection': return campaignStartSection;
			case 'campaignEventTypes': return campaignEventTypes;
			case 'emailType': return emailType;
			case 'scheduleTimeZone': return scheduleTimeZone;
			case 'emailAttachmentFileTypes': return emailAttachmentFileTypes;
			case 'fileValidationError': return fileValidationError;
			default:
				throw 'Unknown enumeration type: ' + type;
		}
	}

	return service;
})();